import {
  Button,
  DatePicker,
  Descriptions,
  Modal,
  PageHeader,
  Spin,
  Space,
  Form,
  Select,
  Input,
  Menu,
  Dropdown,
  Radio,
  message,
} from "antd";
import React, { Component } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import { connect } from "react-redux";
import moment from "moment";
import { professionalAction } from "../../_actions";
import { NoticeTable } from "./Tables/notice";
import { ViewFormModel } from "./ViewForm/ViewFormModel";
import * as XLSX from "xlsx-js-style";
import _ from "lodash";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  BarChartOutlined,
  ClearOutlined,
  DownOutlined,
  FilterOutlined,
  SearchOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { roleAction } from "../../_actions/roleby.action";
import { adminServiceAction } from "../../_actions/admin.service";
import { RoleByService } from "../../_services/roleby.service";
import {
  downloadReportPdf,
  getDefaultReportFooter,
  getReportDateRangeText,
  getReportHeaderText,
} from "../../_helpers/downloadReportPdf";
const { RangePicker } = DatePicker;
const { Option } = Select;

class NoticeReport extends Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.state = {
      report_4_startDate: "",
      report_4_endDate: "",
      report4_API_loader: false,
      report4_List: [],
      download: "excel",
      downloadLoding: false,
      showFilterSection: false,
      search: "",
      searchText: "",
      showList: "list",
      total: "0",
      advancedFilterPhoto: "all",
    };
  }

  downloadReport = () => {
    const { download } = this.state;
    if (download == "excel") {
      this.download_csv();
    }
    if (download == "pdf") {
      this.download_pdf();
    }
  };

  getNoticeExportRows = () => {
    const { t } = this.context;
    const arrData1 = this.state.report4_List;

    return this.state.showList === "list"
      ? arrData1?.map((data, index) => ({
          [t("sr.no")]: index + 1,
          [t("notice_police")]: data.action_taken_police_station,
          [t("notice_date")]: moment(data?.notice_date).format("DD/MM/YYYY"),
          [t("name")]: data?.basci_name,
          [t("accused_police_station")]: data?.districtName,
          [t("notice_type")]:
            data?.type === "BNS_35_3"
              ? "भारतीय नागरिक सुरक्षा संहिता २०२३ चे कलम ३५(३) प्रमाणे"
              : "फौजदारी प्रक्रिया संहिता ४१(अ) प्रमाणे",
          [t("total_crimes")]: data?.totalCrimeCount,
          [`${t("cr.no")} / ${t("police_station_of_crime")}`]: `${
            data?.cr_no || "-"
          } / ${data?.guna_districtName || "-"}`,
          [t("photo")]: data.aaropi_photo ? t("yes") : t("no"),
        })) || []
      : arrData1?.map((data, index) => ({
          [t("sr.no")]: index + 1,
          [t("आरोपीचे पो. स्टे")]: data?.districtName,
          [t("count")]: data?.count,
        })) || [];
  };

  download_pdf = async () => {
    const { t } = this.context;
    const arrData = this.getNoticeExportRows();

    if (!arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const title = t("notice_register");
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
      districtName: this.state.district_name,
    });

    this.setState({ downloadLoding: true });
    try {
      await downloadReportPdf({
        headerText,
        reportTitle: title,
        dateRangeText: getReportDateRangeText(
          this.state.report_4_startDate,
          this.state.report_4_endDate
        ),
        arrData,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ downloadLoding: false });
    }
  };

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  componentDidMount() {
    const { user } = this.props;
    if (user && user.role !== "4") {
      this.getDistrictsid();
    }
    this.props.dispatch(professionalAction.getCity());
  }

  getDistrictsid = (id) => {
    const { user } = this.props;
    console.log("users id", this.props);
    professionalAction.getDistrictsid(user.districtId).then((res) => {
      console.log("res", res);

      const tempData = res.pc_districts;
      console.log("text", tempData[0]?.DistrictName);
      this.setState({
        district_name: tempData[0]?.DistrictName,
      });
    });
  };

  download_csv = () => {
    const { t } = this.context;
    var ReportTitle = t("notice_register");
    var title = t("notice_register");
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const arrData = this.getNoticeExportRows();

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length)
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    console.log("this props.user", this.props.user);
    const cityName = this.getCityName(this.props?.user?.cityId || "");
    console.log("cityName", cityName);
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;

    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: ReportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] = {
      v: `From: ${
        moment(this.state.report_4_startDate).format("DD-MM-YYYY") || "-"
      } To ${moment(this.state.report_4_endDate).format("DD-MM-YYYY") || "-"}`,
      t: "s",
    };

    ws["A3"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY"
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
      { s: { r: 2, c: 0 }, e: { r: 2, c: columnWidths.length - 1 } },
    ];

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  onStartDateChange = (date) => {
    if (date) {
      const startDate = date.toISOString();

      this.setState({
        report_4_startDate: startDate,
        report_4_endDate: null, // reset end date when start changes
        isMoreThanOneYear: false,
      });
    } else {
      this.setState({
        report_4_startDate: null,
        report_4_endDate: null,
        isMoreThanOneYear: false,
      });
    }
  };

  onEndDateChange = (date) => {
    if (!date) return;

    const { report_4_startDate } = this.state;

    this.setState({
      report_4_endDate: date.toISOString(),
    });
  };

  disabledEndDate = (current) => {
    const { report_4_startDate } = this.state;
    if (!report_4_startDate) return false;

    const start = moment(report_4_startDate).startOf("day");
    return current.isBefore(start, "day"); // block anything before start date
  };
  getData = () => {
    this.setState({
      report4_API_loader: true,
    });
    const { report_4_startDate, report_4_endDate, searchText, showList } =
      this.state;
    const { user } = this.props;
    if (showList === "list") {
      if (user?.role === "2") {
        const temp = {
          startDate: moment(report_4_startDate).format("YYYY-MM-DD"),
          endDate: moment(report_4_endDate).format("YYYY-MM-DD"),
          districtId: user && user.districtId,
          search: searchText && searchText,
        };
        professionalAction.noticeReport(temp).then((res) => {
          let list = res.results;

          this.setState({
            report4_API_loader: false,
            report4_List: list,
            report4_List_backup: list,
            total: list.length,
          });
        });
      }
      if (user?.role === "4") {
        const temp = {
          startDate: moment(report_4_startDate).format("YYYY-MM-DD"),
          endDate: moment(report_4_endDate).format("YYYY-MM-DD"),
          city: user && user.cityId,
          search: searchText && searchText,
        };

        adminServiceAction.noticeList(temp).then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.results;

              let columns1 =
                list &&
                list &&
                list.map((item, index) => {
                  return {
                    type: item.notice_type,
                    notice_date: item.notice_date,
                    action_taken_police_station:
                      item?.action_taken_police_station,
                    basci_name: item?.basic_name,
                    name: item?.name,
                    aaropi_aadhar_number: item?.aaropi_aadhar_number,
                    aaropi_address: item?.aaropi_address,
                    aaropi_number: item?.aaropi_number,
                    aaropi_photo: item?.aaropi_photo,
                    aaropi_pincode: item?.aaropi_pincode,
                    districtName: item.accused_districtName || "-",
                    totalCrimeCount: item.totalCrimeCount || "-",
                    cr_no: item.cr_no || "-",
                    guna_districtName: item.GunaDistrictName || "-",
                    photo: item.aaropi_photo ? item.aaropi_photo : null,
                    masterId: item.masterId,
                    document: item.document,
                    mobile_no: item.mobile_no,
                    aaropi_aadhar_number: item?.aaropi_aadhar_number,
                    aaropi_address: item?.aaropi_address,
                    aaropi_address: item?.aaropi_address,
                  };
                });

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });

              this.setState({
                report4_API_loader: false,
                report4_List: columns1,
                total: list?.length,
                report4_List_backup: columns1,
              });
            });
        });
      }
      if (user?.role === "9" || user?.role === "10") {
        const temp = {
          startDate: moment(report_4_startDate).format("YYYY-MM-DD"),
          endDate: moment(report_4_endDate).format("YYYY-MM-DD"),
          districtId: user && user.map_districtId,
          search: searchText && searchText,
        };
        RoleByService.noticeListByRole(temp).then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.results;

              this.setState({
                report4_API_loader: false,
                report4_List: list,
                total: list?.length,
                report4_List_backup: list,
              });
            });
        });
      }
    }
    if (showList === "count") {
      if (user.role === "4") {
        const temp = {
          startDate: moment(report_4_startDate).format("YYYY-MM-DD"),
          endDate: moment(report_4_endDate).format("YYYY-MM-DD"),
          city: user && user.cityId,
        };
        adminServiceAction.noticeCount(temp).then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.results;
              let totalCrimeCount = list.reduce(
                (sum, res) => sum + (Number(res.count) || 0),
                0
              );
              this.setState({
                report4_API_loader: false,
                report4_List: list,
                total: totalCrimeCount,
              });
            });
        });
      }
      if (user.role === "9" || user.role === "10") {
        const temp = {
          startDate: moment(report_4_startDate).format("YYYY-MM-DD"),
          endDate: moment(report_4_endDate).format("YYYY-MM-DD"),
          districtId: user && user.map_districtId,
        };
        roleAction.noticeCountByRole(temp).then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.results;
              let totalCrimeCount = list.reduce(
                (sum, res) => sum + (Number(res.count) || 0),
                0
              );
              this.setState({
                report4_API_loader: false,
                report4_List: list,
                total: totalCrimeCount,
              });
            });
        });
      }
    }
  };

  clearFilter = () => {
    this.setState({ searchText: "" }, () => {
      this.getData("");
    });
  };

  onViewAccusedForm = (data) => {
    if (data) {
      let obj = {
        startDate: this.state.report_4_startDate,
        endDate: this.state.report_4_endDate,
        id: data,
        heading: this.state.crimeTitle,
      };
      this.props.dispatch(professionalAction.get2PlusCriminalsViewsById(obj));
      this.showCriminalViewModel();
    }
  };

  showCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: true,
    });
  };
  closeCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: false,
    });
  };
  onFinishDateRangeGPSReport1 = (values) => {
    if (values) {
      let dates =
        values &&
        values.map((item) => {
          return item.toISOString();
        });

      this.setState({
        report_4_startDate: dates[0],
        report_4_endDate: dates[1],
      });
    }
  };

  onStartDateChange = (date) => {
    if (date) {
      const startDate = date.toISOString();

      this.setState({
        report_4_startDate: startDate,
        report_4_endDate: null,
      });
    }
  };
  onEndDateChange = (date) => {
    if (date) {
      const endDate = date.toISOString();

      this.setState({
        report_4_endDate: endDate,
      });
    }
  };
  handleCondition = (e) => {
    this.setState({
      showList: e,
      report4_List: [],
      total: 0,
    });
  };
  sortby = (name, direction) => {
    this.setState({
      order_by: name,
      direction: direction,
    });

    const { report4_List } = this.state;

    const sortedData = [...report4_List].sort((a, b) => {
      let x = a[name] ?? "";
      let y = b[name] ?? "";

      // If both values are numeric strings → sort as numbers
      const isNumeric = !isNaN(x) && !isNaN(y);

      if (isNumeric) {
        x = Number(x);
        y = Number(y);
        return direction === "ASC" ? x - y : y - x;
      }

      // Otherwise sort as strings
      x = x.toString().toLowerCase();
      y = y.toString().toLowerCase();

      return direction === "ASC" ? x.localeCompare(y) : y.localeCompare(x);
    });

    this.setState({ report4_List: sortedData });
  };
  handleAdvancedFilterPhotoChange = (e) => {
    const value = e.target.value;
    this.setState({ advancedFilterPhoto: value });

    const { report4_List_backup, report4_List } = this.state; // keep original data safe

    let filtered;
    if (report4_List_backup.length > 0) {
      if (value === "yes") {
        filtered = report4_List_backup.filter(
          (item) =>
            item.aaropi_photo !== null &&
            item.aaropi_photo !== "" &&
            item.aaropi_photo !== undefined
        );
      } else if (value === "no") {
        filtered = report4_List_backup.filter(
          (item) =>
            item.aaropi_photo === null ||
            item.aaropi_photo === "" ||
            item.aaropi_photo === undefined
        );
      } else {
        filtered = report4_List_backup;
      }
    }

    this.setState({ report4_List: filtered, total: filtered.length });
  };
  render() {
    const { report_4_endDate, report_4_startDate, key, direction } = this.state;
    const { language, t } = this.context;
    const { professionals } = this.props;
    const menu = (
      <Menu onClick={this.filterkey} style={{ width: "200px", padding: "8px" }}>
        {this.state.showList == "list" ? (
          <>
            <Menu.Item key="totalCrimeCount">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                एकुण गुन्हे
                <ArrowUpOutlined
                  title="ASC"
                  style={{
                    color:
                      key === "totalCrimeCount" && direction === "ASC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("totalCrimeCount", "ASC")} // Toggle to ASC
                />
                <ArrowDownOutlined
                  title="DESC"
                  style={{
                    color:
                      key === "totalCrimeCount" && direction === "DESC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("totalCrimeCount", "DESC")} // Toggle to DESC
                />
              </div>
            </Menu.Item>
            <Menu.Item key="name">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {t("name")}
                <ArrowUpOutlined
                  title="ASC"
                  style={{
                    color:
                      key === "name" && direction === "ASC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("name", "ASC")} // Toggle to ASC
                />
                <ArrowDownOutlined
                  title="DESC"
                  style={{
                    color:
                      key === "name" && direction === "DESC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("name", "DESC")} // Toggle to DESC
                />
              </div>
            </Menu.Item>
          </>
        ) : (
          <>
            <Menu.Item key="count">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {t("total")}
                <ArrowUpOutlined
                  title="ASC"
                  style={{
                    color:
                      key === "count" && direction === "ASC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("count", "ASC")} // Toggle to ASC
                />
                <ArrowDownOutlined
                  title="DESC"
                  style={{
                    color:
                      key === "count" && direction === "DESC"
                        ? "#1890ff"
                        : "#bfbfbf",
                  }}
                  onClick={() => this.sortby("count", "DESC")} // Toggle to DESC
                />
              </div>
            </Menu.Item>
          </>
        )}
      </Menu>
    );
    return (
      <>
        <div className="col-md-12">
          {/* Title Section */}

          <div
            style={{
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              background: "#fff",
              border: "1px solid #f0f0f0",
            }}
          >
            {/* Title Section */}
            <div
              style={{
                padding: "16px 20px",
                borderRadius: "8px 8px 0 0",
                background: "#fff",
                marginBottom: "0",
              }}
            >
              <h2
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#262626",
                }}
              >
                {t("notice_register")}
              </h2>
            </div>
            {/* Filter Row with Find/Download Options */}
            <div
              className="border-none box-none filter-row"
              style={{
                position: "relative", // ✅ Add this line
                padding: "16px 20px",
                borderRadius: "0 0 8px 8px",
                background: "#fff",
                marginBottom: "0",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "16px",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
                className="button-group-responsive"
              >
                {/* Left Side - Date Picker and Find Button */}
                <div
                  style={{
                    display: "flex",
                    gap: "16px",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                      flex: "0 0 auto",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#262626",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {t("select_date")}:
                    </span>
                    {/* <RangePicker
                      onChange={(val) => this.onFinishDateRangeGPSReport1(val)}
                      inputReadOnly
                      style={{ width: "250px" }}
                      format={"DD/MM/YYYY"}
                    /> */}
                    <DatePicker
                      style={{ flex: 1, minWidth: "150px" }}
                      value={
                        this.state.report_4_startDate
                          ? moment(this.state.report_4_startDate)
                          : null
                      }
                      onChange={this.onStartDateChange}
                      placeholder="DD/MM/YYYY"
                      allowClear
                      format={"DD/MM/YYYY"}
                      inputReadOnly
                    />
                    <DatePicker
                      style={{ flex: 1, minWidth: "150px", marginLeft: "10px" }}
                      value={
                        this.state.report_4_endDate
                          ? moment(this.state.report_4_endDate)
                          : null
                      }
                      onChange={this.onEndDateChange}
                      placeholder="DD/MM/YYYY"
                      allowClear
                      format={"DD/MM/YYYY"}
                      inputReadOnly
                    />
                  </div>

                  <Button
                    type="primary"
                    disabled={!this.state.report_4_startDate}
                    loading={this.state.report4_API_loader}
                    onClick={this.getData}
                    className="modern-button modern-button-success"
                    style={{ minWidth: "100px" }}
                  >
                    {t("find")}
                  </Button>
                </div>

                {/* Right Side - Download Section */}
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                    flex: "0 0 auto",
                  }}
                >
                  <div className="download-section-responsive margin-0">
                    <div className="download-group-responsive">
                      <Space
                        direction="horizontal"
                        size="middle"
                        className="download-space-responsive"
                      >
                        <Form>
                          <Form.Item
                            name="condition"
                            rules={[
                              {
                                required: true,
                                message: t("please_select_an_option"),
                              },
                            ]}
                            style={{ marginBottom: 0 }}
                          >
                            <Select
                              defaultValue={this.state.download}
                              placeholder={t("please_select_an_option")}
                              value={this.state.download}
                              onChange={(value) =>
                                this.setState({ download: value })
                              }
                              className="download-select-responsive"
                              disabled={!this.state.report4_List?.length}
                              style={{ width: "120px" }}
                            >
                              <Option key="excel" value="excel">
                                {t("excel")}
                              </Option>
                              <Option key="pdf" value="pdf">PDF</Option>
                            </Select>
                          </Form.Item>
                        </Form>

                        {this.state.download && (
                          <Button
                            type="primary"
                            className="download-button-responsive download-button-success"
                            onClick={() => this.downloadReport()}
                            disabled={!this.state.report4_List?.length}
                            loading={this.state.downloadLoding}
                            style={{ minWidth: "100px" }}
                          >
                            {t("download")}
                          </Button>
                        )}
                      </Space>
                    </div>
                  </div>
                </div>
                <Dropdown
                  overlay={menu}
                  placement="bottomRight"
                  arrow
                  disabled={!this.state.report4_List?.length}
                >
                  <Button type="ghost">
                    {t("sorter_by")} <DownOutlined />
                  </Button>
                </Dropdown>
              </div>

              {/* ✅ Filter Button - stays bottom right within the box */}
              {this.state.showList === "list" && (
                <Button
                  icon={<FilterOutlined />}
                  onClick={() =>
                    this.setState({
                      showFilterSection: !this.state.showFilterSection,
                    })
                  }
                  disabled={!this.state.report4_List.length}
                  style={{
                    position: "absolute",
                    bottom: "12px",
                    right: "20px",
                    borderRadius: "6px",
                  }}
                >
                  {t("filter")}
                </Button>
              )}
            </div>
            {this.state.showFilterSection == true && (
              <div
                style={{
                  marginTop: "16px",
                  padding: "16px",
                  background: "#fff",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                  marginBottom: "25px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    flexWrap: "wrap", // responsive wrap
                  }}
                >
                  <Input
                    value={this.state.searchText}
                    onChange={(e) =>
                      this.setState({ searchText: e.target.value })
                    }
                    placeholder={t("search")}
                    style={{ width: 250, marginBottom: 8, display: "block" }}
                  />
                  <Button
                    type="primary"
                    icon={<SearchOutlined />}
                    className="modern-button modern-button-success"
                    onClick={this.getData}
                    style={{ marginBottom: "8px" }}
                  >
                    {t("find")}
                  </Button>

                  <Button
                    icon={<ClearOutlined />}
                    className="modern-button modern-button-danger"
                    onClick={this.clearFilter}
                    style={{ marginBottom: "8px" }}
                  >
                    {t("clear")}
                  </Button>
                </div>
              </div>
            )}
            <div style={{ margin: "10px" }}>
              {this.state.showList === "list" && (
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                  }}
                >
                  <label style={{ fontSize: "15px", fontWeight: "500" }}>
                    फोटो:
                  </label>

                  <Radio.Group
                    onChange={this.handleAdvancedFilterPhotoChange}
                    value={this.state.advancedFilterPhoto}
                  >
                    <Radio value="all">सर्व</Radio>
                    <Radio value="yes">होय</Radio>
                    <Radio value="no">नाही</Radio>
                  </Radio.Group>
                </div>
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "12px",
              alignItems: "center",
              padding: "12px",
              background: "#f5f5f5",
              borderRadius: "8px",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "8px",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              {this.props.user &&
                (this.props.user.role === "4" ||
                  this.props.user.role === "9" ||
                  this.props.user.role === "10") && (
                  <Button
                    type={
                      this.state.showList === "count" ? "primary" : "default"
                    }
                    icon={<BarChartOutlined />}
                    style={{ minWidth: "120px" }}
                    onClick={() => this.handleCondition("count")}
                  >
                    {t("statistics")}
                  </Button>
                )}

              <Button
                type={this.state.showList == "list" ? "primary" : "default"}
                icon={<UnorderedListOutlined />}
                style={{ minWidth: "120px" }}
                onClick={() => this.handleCondition("list")}
              >
                {t("list")}
              </Button>
            </div>
          </div>
          <React.Suspense>
            <NoticeTable
              data={this.state.report4_List}
              loading={this.state.report4_API_loader}
              professionals={this.props.professionals}
              onViewAccusedForm={this.onViewAccusedForm}
              user={this.props.user}
              dispatch={this.props.dispatch}
              showList={this.state.showList}
              total={this.state.total}
              startDate={this.state.report_4_startDate}
              endDate={this.state.report_4_endDate}
            />
          </React.Suspense>

          <Modal
            title="आरोपी प्रोफाइल"
            top
            visible={this.state.setCriminalViewModel}
            onOk={this.closeCriminalViewModel}
            onCancel={this.closeCriminalViewModel}
            width={95 + "%"}
          >
            <ViewFormModel
              key={this.props && this.props.user.id}
              dataStates={professionals}
            ></ViewFormModel>
          </Modal>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;

  return {
    user,
    users,
    professionals,
  };
}

const connectedNoticeReport = connect(mapStateToProps)(NoticeReport);
export { connectedNoticeReport as NoticeReport };
